"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
class Config {
    /**
     * Load an environment
     *
     * @param environment
     */
    static load(environment) {
        Config.environment = environment;
    }
    /**
     * Fetch current loaded configuration
     *
     * @returns
     */
    static fetch() {
        if (!Config.environment) {
            throw new Error("[Config] No environment configuration was loaded");
        }
        return Config.environment;
    }
}
exports.Config = Config;
//# sourceMappingURL=config.js.map